import { ControlledCheckbox } from 'components/Form';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import type { Control } from 'react-hook-form';

interface TCheckboxHeaderRenderer extends ICellRendererParams<any> {
    control: Control;
}
export const GroupManagerCheckboxHeaderRenderer = (props: TCheckboxHeaderRenderer) => {
    const { control } = props;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '2px',
            }}
        >
            <ControlledCheckbox control={control} name="headerCheckbox" />
        </div>
    );
};

GroupManagerCheckboxHeaderRenderer.displayName = 'GroupManagerCheckboxHeaderRenderer';
